/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const fr_years_tech_experience_insight = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Après plus de <strong class="text-blue-400">8 ans dans le monde tech</strong> — des startups aux grands groupes — j'ai compris une vérité essentielle : <strong class="text-juslin-gold">la technologie n'est qu'un outil</strong>. Ce qui compte vraiment, c'est l'impact qu'elle génère.`)
};

const en_years_tech_experience_insight = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`After more than <strong class="text-blue-400">8 years</strong> in the tech world — from startups to large corporations, from Paris to Dakar — I understood one essential thing: <strong class="text-juslin-gold">technology is just a tool</strong>. What truly matters is the impact it creates.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const years_tech_experience_insight = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.years_tech_experience_insight(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("years_tech_experience_insight", locale)
	if (locale === "fr") return fr_years_tech_experience_insight(inputs)
	return en_years_tech_experience_insight(inputs)
};